var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2079 12.38C16.7908 12.1646 14.7128 11.1416 14.3263 11.0032C13.9398 10.857 13.6566 10.7878 13.3773 11.2185C13.0941 11.6454 12.2905 12.5954 12.0379 12.8838C11.793 13.1684 11.5443 13.203 11.1271 12.9915C8.64736 11.7454 7.02098 10.7686 5.38693 7.94953C4.9545 7.19958 5.81936 7.25342 6.62682 5.6343C6.76458 5.3497 6.6957 5.10741 6.58855 4.89204C6.4814 4.67667 5.6395 2.5922 5.28744 1.74226C4.94685 0.91539 4.59479 1.03077 4.33839 1.01538C4.09347 1 3.81412 1 3.53093 1C3.24775 1 2.79236 1.10769 2.40586 1.52689C2.01935 1.95378 0.928711 2.98064 0.928711 5.06511C0.928711 7.14958 2.4403 9.16867 2.64694 9.45327C2.86124 9.73787 5.62037 14.0145 9.85664 15.8567C12.5354 17.0181 13.5839 17.1181 14.9233 16.9181C15.7384 16.7951 17.4184 15.8951 17.7666 14.8991C18.1149 13.9068 18.1149 13.0569 18.0115 12.88C17.9082 12.6915 17.625 12.5838 17.2079 12.38Z",
    stroke: "#505050",
    strokeWidth: 1.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.b128934369abaedefd9e3da0e4e364ea.svg";
export { ForwardRef as ReactComponent };